import { render } from "./FormAreaCheckbox.vue?vue&type=template&id=06d0d799&scoped=true&bindings={\"label\":\"props\",\"items\":\"props\",\"id\":\"props\",\"enableAllCheck\":\"props\",\"titleHasBorder\":\"props\",\"variableSize\":\"props\",\"gatAllOnce\":\"props\",\"state\":\"setup\",\"status\":\"setup\",\"handleToggle\":\"setup\",\"checkAll\":\"setup\",\"checkSingle\":\"setup\"}"
import script from "./FormAreaCheckbox.vue?vue&type=script&lang=ts"
export * from "./FormAreaCheckbox.vue?vue&type=script&lang=ts"

import "./FormAreaCheckbox.vue?vue&type=style&index=0&id=06d0d799&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-06d0d799"

export default script